import { useNavigation, useRoute } from '@react-navigation/native';
import React, { useState } from 'react';
import { Platform, StyleSheet, View } from 'react-native';
import { Screens } from '../../../constants/ScreenNames';
import { Color, CommonProperties } from '../../../styles';
import BottomButton from '../../BottomButton';
import WrapBottomColor from '../../containers/WrapBottomColor';
import InputAnimated from '../../InputAnimated';
import SwitchWithLabel from '../../SwitchWithLabel';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { selectCurrentEvent } from '../../../store/selectors/events.selector';
import TimeInput from '../../TimeInput';
import DateSelector from '../../DateSelector';
import { triphubTabs } from '../../../constants/Enums';
import {
  addTripEvent,
  deleteTripEvents,
  setSelectedEvent,
  updateTripEvent,
} from '../../../store/actions/events';
import Button from '../../Button';
import { useTranslation } from 'react-i18next';
import { i18nNS, useComponentTKey } from '../../../i18n';
import { scale } from '../../../utils/scale.utils';

const MeetingFormModal = () => {
  const { t } = useTranslation(i18nNS.tripHub);
  const { tKey } = useComponentTKey('MeetingFormModal');
  const navigation = useNavigation();
  const route = useRoute();
  const trip = route.params.trip;
  const currentEvent = useSelector(selectCurrentEvent);
  const [activity, setActivity] = useState(
    currentEvent
      ? {
          ...currentEvent,
          StartDate: currentEvent.EventDate,
          StartTime: {
            hours: new Date(currentEvent.EventDate).getHours(),
            minutes: new Date(currentEvent.EventDate).getMinutes(),
          },
          Shared: !!currentEvent.Share,
        }
      : {
          StartDate: moment(new Date(route.params.trip.FromDate)).hours(0).minutes(0).toDate(),
          StartTime: {
            hours: 0,
            minutes: 0,
          },
          TripKey: route.params.trip.Id,
          Title: '',
        }
  );
  const disabledSubmit = activity.Title.length === 0;

  const dispatch = useDispatch();

  const changeActivityField = (field) => (value) => setActivity({ ...activity, [field]: value });

  const onSubmit = () => {
    if (currentEvent) {
      dispatch(
        updateTripEvent({
          Title: activity.Title,
          Share: +activity.Shared,
          CreateDate: moment(activity.StartDate).format(),
          EventDate: moment(activity.StartDate).format(),
          TripKey: route.params.trip.TripId,
          Id: activity.Id,
        })
      );
    } else {
      dispatch(
        addTripEvent({
          Title: activity.Title,
          TripKey: route.params.trip.TripId,
          CreateDate: moment(activity.StartDate).format(),
          EventDate: moment(activity.StartDate).format(),
          Share: +activity.Shared,
        })
      );
    }

    dispatch(setSelectedEvent(null));
    navigation.navigate(Screens.TripHub, { initialTab: triphubTabs.EVENT });
  };

  const onDelete = () => {
    dispatch(deleteTripEvents(currentEvent.Id));
    navigation.navigate(Screens.TripHub, { initialTab: triphubTabs.EVENT });
  };

  return (
    <WrapBottomColor disabled={disabledSubmit}>
      <View style={styles.container}>
        <DateSelector
          initialValue={activity.StartDate}
          minDate={Array.isArray(trip) ? new Date(trip[0].FromDate) : new Date(trip.FromDate)}
          maxDate={Array.isArray(trip) ? new Date(trip[0].ToDate) : new Date(trip.ToDate)}
          onChangeDate={(day) =>
            changeActivityField('StartDate')(
              moment(day)
                .hours(new Date(activity.StartDate).getHours())
                .minutes(new Date(activity.StartDate).getMinutes())
                .toDate()
            )
          }
          label={t(tKey('SelectDate'))}
        />
        <TimeInput
          initialValue={
            activity.StartTime || {
              hours: new Date(activity.StartDate).getHours(),
              minutes: new Date(activity.StartDate).getMinutes(),
            }
          }
          label={t(tKey('SelectTime'))}
          value=""
          onChange={(time) =>
            changeActivityField('StartDate')(
              moment(activity.StartDate).hours(time.hours).minutes(time.minutes).toDate()
            )
          }
        />
        <SwitchWithLabel
          left
          label={t(tKey('ShareWithOthers'))}
          value={activity.Shared}
          onChange={() => changeActivityField('Shared')(!activity.Shared)}
        />
        <InputAnimated
          label={t(tKey('Activity'))}
          value={activity.Title}
          onChangeText={changeActivityField('Title')}
          multiline
          numberOfLines={4}
          style={Platform.OS === 'ios' ? styles.activityIOS : null}
        />
        {!!currentEvent && (
          <Button onPress={onDelete} label={t(tKey('Delete'))} color={Color.required} />
        )}
      </View>
      <BottomButton
        disabled={disabledSubmit}
        label={currentEvent ? t(tKey('Edit')) : t(tKey('Add'))}
        onPress={onSubmit}
        full
      />
    </WrapBottomColor>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: Color.accent,
    ...CommonProperties.p3,
  },
  activityIOS: {
    minHeight: scale(150),
  },
});

export default MeetingFormModal;
